import React from 'react'
import { observer } from 'mobx-react'

import CollapseIcon from '@components/Icon/Collapse'
import ExpandIcon from '@components/Icon/Expand'
import OrderDown from '@components/Icon/OrderDown'
import OrderUp from '@components/Icon/OrderUp'

const SegmentActions = observer(
  ({ expanded, onClick, orderSegmentDown, orderSegmentUp }) => {
    const icon = expanded ? <CollapseIcon onClick={onClick} /> : <ExpandIcon />
    return (
      <div className='segment-actions'>
        <span
          className='m-t-md m-r-md'
          onClick={e => {
            e.stopPropagation()
            orderSegmentDown()
          }}
        >
          <OrderDown />
        </span>
        <span
          className='m-t-md m-r-lg'
          onClick={e => {
            e.stopPropagation()
            orderSegmentUp()
          }}
        >
          <OrderUp />
        </span>
        {icon}
      </div>
    )
  }
)

export default SegmentActions
